import { getCategory, getCountryCodes, getFaqCodes, getNoticeCodes ,getCategoryDepth} from "@/api/common";
import { modalService } from "@/services/modalService";

const commonStore = {
    namespaced: true,
    state: {
        categories: [],
        categoryDepthList:[],
        countryCodes: [],
        faqCodes: [],
        noticeCodes: [],
    },
    getters: {
        categories(state) {
            return state.categories;
        },
        categoryDepth(state) {
            return state.categoryDepthList;
        },
        countryCodes(state) {
            return state.countryCodes;
        },
        faqCodes(state) {
            return state.faqCodes;
        },
        noticeCodes(state) {
            return state.noticeCodes;
        },
    },
    mutations: {
        SET_CATEGORIES(state, categoryList) {
            state.categories.push(...categoryList);
        },
        SET_CATEGORIES_DEPTH(state, categoryDepthList) {
            state.categoryDepthList.push(...categoryDepthList);
        },
        SET_COUNTRY_CODES(state, countryCodeList) {
            state.countryCodes.push(...countryCodeList);
        },
        SET_FAQ_CODES(state, faqCodeList) {
            state.faqCodes.push(...faqCodeList);
        },
        SET_NOTICE_CODES(state, noticeCodes) {
            state.noticeCodes.push(...noticeCodes);
        },
    },
    actions: {
        async GET_CATEGORIES({ state, commit }) {
            if (state.categories.length == 0) {
                try {
                    const { data } = await getCategory();
                    commit("SET_CATEGORIES", data.data);
                } catch (err) {
                    const content = err.response?.data?.message ?? "데이터를 불러오는 중 오류가 발생하였습니다.";
                    modalService.alert({ title: "알림", content });
                }
            }
        },
        async GET_CATEGORY_DEPTH({ state, commit }) {
            if (state.categoryDepthList.length == 0) {
                try {
                    const { data } = await getCategoryDepth();
                    commit("SET_CATEGORIES_DEPTH", data.data);
                } catch (err) {
                    const content = err.response?.data?.message ?? "데이터를 불러오는 중 오류가 발생하였습니다.";
                    modalService.alert({ title: "알림", content });
                }
            }
        },
        async GET_COUNTRY_CODES({ state, commit }) {
            if (state.countryCodes.length == 0) {
                try {
                    const { data } = await getCountryCodes();
                    commit("SET_COUNTRY_CODES", data.data);
                } catch (err) {
                    const content = err.response?.data?.message ?? "데이터를 불러오는 중 오류가 발생하였습니다.";
                    modalService.alert({ title: "알림", content });
                }
            }
        },
        async GET_FAQ_CODES({ state, commit }) {
            if (state.faqCodes.length == 0) {
                try {
                    const { data } = await getFaqCodes();
                    commit("SET_FAQ_CODES", data.data);
                } catch (err) {
                    const content = err.response?.data?.message ?? "데이터를 불러오는 중 오류가 발생하였습니다.";
                    modalService.alert({ title: "알림", content });
                }
            }
        },
        async GET_NOTICE_CODES({ state, commit }) {
            if (state.noticeCodes.length == 0) {
                try {
                    const { data } = await getNoticeCodes();
                    commit("SET_NOTICE_CODES", data.data);
                } catch (err) {
                    const content = err.response?.data?.message ?? "데이터를 불러오는 중 오류가 발생하였습니다.";
                    modalService.alert({ title: "알림", content });
                }
            }
        },
    },
}

export default commonStore;